import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import { checkOriginNonProd, translate } from '../../../../utils/util';
import { checkPermission, getVision } from '../../../../services/auth';
import { PERMISSIONS, ENUMS, VISIONS } from '../../../../utils/constants';
import JustificationService from '../../../../services/JustificationService';
import * as packListAction from '../../../../actions/packListAction';
import * as pickingAction from '../../../../actions/pickingAction';

const Picking = (props) => {
    const menu = () => {
        let menuItems = [];

        if (checkPermission(PERMISSIONS.Expedition.Picking.Filters)) {
            menuItems = [...menuItems, { route: 'picking/filter', icon: 'mdi mdi-filter-outline', text: translate('expedition:picking.filter') }];
        }

        if (checkPermission(PERMISSIONS.Expedition.Picking.Access)) {
            menuItems = [...menuItems, { route: 'picking/ondemand', icon: 'compare_arrows', text: translate('expedition:picking.ondemand') }];
            menuItems = [...menuItems, {
                route: {
                    pathname: 'endCalls',
                    state: { orderType: ENUMS.eOrderType.Picking.value }
                },
                icon: "mdi mdi-close-network-outline",
                text: translate('line-picking:endCalls:endCall')
            }];


            if (checkPermission(PERMISSIONS.Expedition.Picking.Voice)) {
                menuItems = [...menuItems, { route: 'picking/voice', icon: 'headset_mic', text: translate('expedition:picking.voice') }];
            }

            menuItems = [...menuItems, {
                route: {
                    pathname: 'picking/transmissions',
                    state: { type: ENUMS.eOrderType.Picking.value }
                },
                icon: "mdi mdi-close-network-outline",
                text: translate('expedition:picking.transmissions')
            }];

        }

        if (checkPermission(PERMISSIONS.Expedition.PackList.Access) && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            menuItems = [...menuItems,
            {
                route: 'picking/packinglist',
                icon: 'mdi mdi-folder-text-outline',
                text: translate('expedition:picking.packList'),
                onClick: () => {
                    props.resetFilter();
                    props.getJustifications(props.user.vision, {});
                }
            }];
        }



        menuItems = [...menuItems, { route: 'picking/filter/orderitem', icon: 'mdi mdi-dolly', text: translate('expedition:picking.writeoff-tasks') }];

        menuItems = [...menuItems, {
            onClick: () => {
                props.resetCimFile();
            },
            route: {
                pathname: 'picking/cimFile',
                state: { expeditionCim: false }
            },
            icon: 'mdi mdi-file-table-outline',
            text: translate('expedition:picking.generate-spreadsheet')
        }];

        menuItems = [...menuItems, {
            onClick: () => {
                props.resetCimFile();
            },
            route: {
                pathname: 'picking/cimFile',
                state: { expeditionCim: true }
            },
            icon: 'mdi mdi-file-table-outline',
            text: translate('expedition:picking.generate-expedition-cim')
        }];
        menuItems = [...menuItems, { route: 'picking/automaticfinalizationorder', icon: 'mdi mdi-dolly', text: translate('expedition:picking.writeoff-orders') }];
        menuItems = [...menuItems, { route: 'picking/automaticfinalization', icon: 'mdi mdi-calendar-multiple-check', text: translate('expedition:picking.automatic-finalization') }];

        menuItems = [...menuItems, {
            route: 'picking/print/identification',
            icon: 'filter_frames',
            text: translate('identification-label', 'physical-confirmation')
        }];


        if (getVision() === VISIONS.Jeep) {
            menuItems = [...menuItems, { route: 'picking/invoice', icon: 'compare_arrows', text: translate('expedition:picking.invoice') }];
            menuItems = [...menuItems, { route: 'logGcp', icon: 'mdi mdi-file-alert-outline', text: translate('log-gcp', 'expedition:picking') }];
        }

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('expedition:picking.title')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '2px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        },
        resetFilter: () => {
            dispatch(packListAction.resetFilter());
        },
        resetCimFile: () => {
            dispatch(pickingAction.updateCimFile({}))
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Picking)));
